import { HttpClient } from '@angular/common/http';
import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class IpService {

    constructor(
        private http: HttpClient
    ) {
    }

    getPublicIp(){
        return new Promise((resolve, reject) => {
          this.http.get('http://ipinfo.io').subscribe((data: any) => {
              resolve(data.ip)
          }, err => {
              reject(err);
          });
      });
    }

}

